import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { IconButton } from 'native-base';
import React from 'react';

import { HeaderProps } from '.';

export const HeaderDesktop: React.FC<HeaderProps> = ({
  handleOpenInfo,
  isOpened,
  currentValue,
  title,
}) => {
  return (
    <HStack alignItems="center" justifyContent="space-between">
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        {title}
      </Text>

      <HStack space={Spacing['inline.xxxs']} alignItems="center">
        <Text variant="semibold" fontSize={Typography['fontsize.xs']} color="neutral.dark">
          Valor atual: {currentValue}
        </Text>
        <IconButton
          p={0}
          variant="unstyled"
          onPress={handleOpenInfo}
          icon={
            <Icon
              testID="accordion-chevron-icon"
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size="xs"
              color={Color['neutral.dark']}
            />
          }
        />
      </HStack>
    </HStack>
  );
};
